/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Invite_Share_TextInputs */

const en_us2_invite_share_text = /** @type {(inputs: Invite_Share_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I'm training with MyPocketGym. If you create an account, use my invite: ${i?.code}.`)
};

const pt_br2_invite_share_text = /** @type {(inputs: Invite_Share_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estou treinando com o MyPocketGym. Se você criar uma conta, use meu convite: ${i?.code}.`)
};

const pt_pt2_invite_share_text = /** @type {(inputs: Invite_Share_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estou treinando com o MyPocketGym. Se você criar uma conta, use meu convite: ${i?.code}.`)
};

/** @type {(inputs: Invite_Share_TextInputs) => LocalizedString} */
const es_419_invite_share_text = en_us2_invite_share_text;

/** @type {(inputs: Invite_Share_TextInputs) => LocalizedString} */
const fr_fr2_invite_share_text = en_us2_invite_share_text;

/** @type {(inputs: Invite_Share_TextInputs) => LocalizedString} */
const de_de2_invite_share_text = en_us2_invite_share_text;

/** @type {(inputs: Invite_Share_TextInputs) => LocalizedString} */
const it_it2_invite_share_text = en_us2_invite_share_text;

/**
* | output |
* | --- |
* | "I'm training with MyPocketGym. If you create an account, use my invite: {code}." |
*
* @param {Invite_Share_TextInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_share_text = /** @type {((inputs: Invite_Share_TextInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Share_TextInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_share_text(inputs)
	if (locale === "es-419") return es_419_invite_share_text(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_share_text(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_share_text(inputs)
	if (locale === "de-DE") return de_de2_invite_share_text(inputs)
	if (locale === "it-IT") return it_it2_invite_share_text(inputs)
	return en_us2_invite_share_text(inputs)
});
export { invite_share_text as "invite.share_text" }